// extracted by mini-css-extract-plugin
module.exports = {"flexInputs":"FlexInputs_flexInputs__3icfI"};